import {
  Avatar,
  Backdrop,
  Badge,
  CircularProgress,
  Grid,
  IconButton,
  Menu,
  MenuItem,
  Paper,
  Tooltip,
  Typography,
  Box,
} from "@mui/material";
import TravelIcon from "@mui/icons-material/DirectionsCar";
import EmailIcon from "@mui/icons-material/Email";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import PhoneIcon from "@mui/icons-material/Phone";
import SalaryIcon from "@mui/icons-material/Payment";
import PlaceIcon from "@mui/icons-material/Place";
import SchoolIcon from "@mui/icons-material/School";
import ContractIcon from "@mui/icons-material/Timelapse";
import EmojiPeopleIcon from '@mui/icons-material/EmojiPeople';
import StarBorderIcon from '@mui/icons-material/StarBorder';
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import WorkIcon from '@mui/icons-material/Work';
import GroupIcon from '@mui/icons-material/Group';
import { API, Storage } from "aws-amplify";
import { post } from "../../../actions/api";
import _, { get } from "lodash";
import React, { useState, useEffect } from 'react';
import moment from 'moment';
import { useSelector, useDispatch } from "react-redux";
import {
  getCandidateEngagements,
  getSkillsInfo,
  addNewSkill,
  editSkillLevel,
  saveSkills,
  createValidationRequest
} from "../../../actions/candidates_actions";
import config from "../../../config";
import { TabControl } from "../../Common/TabControl";
import JobResults from "../../Skillzminer/JobResults";
import { BackpackMatches } from "./BackpackMatches";
import { getUrl } from "aws-amplify/storage";
import { CandidateEngagement } from "./CandidateEngagement";
import { CandidateSummaryView } from "./CandidateSummaryView";
import { OtherAssessments } from "./OtherAssessments";
import { Utilisation } from "./Utilisation";

const OptionsMenu = ({
  candidate,
  portaldetails: { missions, interventions: organizationInterventions },
  auth,
}) => {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [showBackdrop, setShowBackdrop] = React.useState(false);
  const [backdropText, setBackdropText] = React.useState("Generating PDF...");
  return (
    <div>
      <Backdrop
        sx={{ zIndex: (theme) => theme.zIndex.drawer + 1, color: "#FFF" }}
        open={showBackdrop}
        onClick={() => {
          if (backdropText.toLowerCase().includes("sorry")) {
            setShowBackdrop(false);
          }
        }}
      >
        <CircularProgress color="inherit" />
        <Typography sx={{ ml: "1em" }}>{backdropText}</Typography>
      </Backdrop>
      <IconButton
        aria-label="more"
        aria-controls="long-menu"
        aria-haspopup="true"
        onClick={(e) => setAnchorEl(e.currentTarget)}
      >
        <MoreVertIcon />
      </IconButton>
      <Menu
        id="long-menu"
        anchorEl={anchorEl}
        // keepMounted
        open={Boolean(anchorEl)}
        onClose={() => setAnchorEl(null)}
      >
        <MenuItem
          onClick={async () => {
            setBackdropText(`Generating PDF...`);
            setShowBackdrop(true);
            let sortedmissions = [];
            _.each(missions, (item) => {
              //GET SCORES

              var newItem = {
                ...item,
              };
              newItem.score = "100"
              //GET STATUS
              if (candidate.missionsAnalytics) {
                _.each(candidate.missionsAnalytics, (mission) => {
                  if (mission.missionId === item.id) {
                    if (
                      newItem.status !== "Completed" &&
                      mission.event_type === "missionStart"
                    ) {
                      newItem.status = "Started";
                    }

                    if (mission.event_type === "missionAssumedComplete") {
                      newItem.status = "Completed";
                    }
                  }
                });
              }
              sortedmissions.push(newItem);
            });

            // sortedmissions = _.sortBy(sortedmissions, ["status"]);
            delete candidate.style_matches;
            delete candidate.interest_matches;

            const payload = {
              sortedmissions,
              ...candidate,
              organizationInterventions,
            };

            try {
              await post("/pdf-service/candidate-pdf", { candidate: payload });
              const getUrlResult = await getUrl({
                path: ({ identityId }) => `private/${identityId}/candidate-pdf/${candidate.userID}.pdf`
              });
              const blob = await (await fetch(getUrlResult.url.href, { method: "get" })).blob();
              const blobUrl = URL.createObjectURL(blob);
              const anchor = document.createElement("a");
              anchor.href = blobUrl;
              anchor.download = `${candidate.fullName}.pdf`;
              anchor.click();
              setShowBackdrop(false);
            } catch (error) {
              console.log(error);
              setBackdropText(
                `Sorry, couldn't generate PDF at the moment. Please try again`
              );
            }
          }}
        >
          Download PDF
        </MenuItem>
      </Menu>
    </div>
  );
};

export const CandidateHeader = ({
  candidate,
  user,
  portaldetails,
  auth,
  onMatchClick,
  onJobClick,
  isInternalMobility,
}) => {
    if (!candidate) {
      return null;
    }
    const {
      lastAuthenticatedAt,
      latestAssessmentCreatedAt,
      assessmentVersion,
      occupations,
      desiredOccupations,
      desiredExp,
      //reassessmentTriggeredAt,
      email,
      phoneNumber,
      phonePreferred,
      locationOriginal,
      // organisation,
      qualifications,
      latestAssessmentResult,
      candidateStatus,
      allow_reverse_mine,
      provider = "",
      internalMobilityLineManager,
      internalMobilityDepartment,
      internalMobilityLocation,
      profileUrl,
    } = candidate;
    const {
      firstName = "",
      lastName = "",
      fullName = "",
    } = user || {}

    const imDepartments = (portaldetails.internalDepartments ? portaldetails.internalDepartments : []).reduce((a, v) => ({ ...a, [v.ID]: v}), {});
    const imLineManagers = (portaldetails.internalLineManagers ? portaldetails.internalLineManagers : []).reduce((a, v) => ({ ...a, [v.userID]: v}), {});
    const imLocations = (portaldetails.internalLocations ? portaldetails.internalLocations : []).reduce((a, v) => ({ ...a, [v.ID]: v}), {});
    
    let locationString = isInternalMobility && imLocations[internalMobilityLocation] ? imLocations[internalMobilityLocation].locationName : locationOriginal 

    const { interests = {} } = latestAssessmentResult || {};

    const { name: qualificationsName = "User not sure or missing" } =
      qualifications || {};

    const { salary = [""], contract = [""] } = interests;

    const desiredOccupationList = () => {
      if(isInternalMobility){
        let occupations = [];
        for (const idx in desiredExp) {
          const roleTitle = portaldetails.internalRoles.find((_item) => _item.occupation.includes(desiredOccupations[idx]));
          if(roleTitle){
            occupations.push(roleTitle.roleName)
          }
          else{
            occupations.push(desiredOccupations[idx])
          }
        }  
        return [...new Set(occupations)].join(", ")
      }
      else{
        return candidate.desiredOccupations.join(", ")
      }
    }

    const occupationList = () => {

      let occupations = {};
      for (const idx in desiredExp) {
        if (desiredExp[idx]){
          occupations[desiredOccupations[idx]] = desiredOccupations[idx];
        }
      }
      _.each(candidate.occupations, (o) => {
        occupations[o] = o;
      });
      let _text = "";
      _.each(Object.keys(occupations), (o, index) => {
          if (Object.keys(occupations).length === (index + 1)){
          _text += o;
          } else {
          _text += o +", ";
          }
      });
      return _text;
      
    }
    let showStatus = true
    const usersProvider = portaldetails.providers ? portaldetails.providers.find((pv) => pv.sort === provider) : false
    if (usersProvider && usersProvider.viewPermissions && usersProvider.viewPermissions.additionalPersonalInfoCheckbox){
      showStatus = false
    }

    return (
      <Paper sx={{ p: 3 }}>
        <Grid container spacing={2}>
          <Grid item size={6}>
            <Grid container spacing={2}>
              <Grid item>
                {profileUrl ? (
                  <Avatar sx={{ width: 56, height: 56, mr: 1 }} src={profileUrl}/>
                ): (
                  <AccountCircleIcon sx={{mr: 0.625, width: 60, height:60, color: "#ff6a14"}}/>
                )}
              </Grid>
              <Grid item size="grow">
                <Grid
                  container
                  direction="column"
                  justify="flex-start"
                  alignItems="stretch"
                  spacing={1}
                >
                  <Grid item>
                    <Typography variant="h4" sx={{ maxWidth: 400, fontSize: "2rem", fontWeight: 500 }}>
                      {fullName}
                      {isInternalMobility && (
                        <IconButton>
                          <Tooltip title="Rising Start">
                            <StarBorderIcon/>
                          </Tooltip>
                        </IconButton>
                      )}
                    </Typography>
                  </Grid>
                  <Grid item>
                    <Grid container spacing={1}>
                      <Grid item>
                        <Badge
                          color="primary"
                          variant="dot"
                          invisible={phonePreferred}
                        >
                          <EmailIcon
                            fontSize="small"
                            sx={{ color: "#666" }}
                          />
                        </Badge>
                      </Grid>
                      <Grid item>
                        {" "}
                        <Typography variant="body2">{email}</Typography>{" "}
                      </Grid>
                    </Grid>
                  </Grid>

                  {phoneNumber && (
                    <Grid item>
                      <Grid container spacing={1}>
                        <Grid item>
                          <Badge
                            color="primary"
                            variant="dot"
                            invisible={!phonePreferred}
                          >
                            <PhoneIcon
                              fontSize="small"
                              sx={{ color: "#666" }}
                            />
                          </Badge>
                        </Grid>
                        <Grid item>
                          {" "}
                          <Typography variant="body2">
                            {phoneNumber}
                          </Typography>{" "}
                        </Grid>
                      </Grid>
                    </Grid>
                  )}

                  <Grid item>
                    <Grid container spacing={1}>
                      <Grid item>
                        <PlaceIcon
                          fontSize="small"
                          sx={{ color: "#666" }}
                        />{" "}
                      </Grid>

                      <Grid item>
                        <Typography variant="body2">{locationString}</Typography>
                      </Grid>
                    </Grid>
                  </Grid>
                  {!isInternalMobility && (
                    <Grid item>
                      <Grid container spacing={1}>
                        <Grid item>
                          <TravelIcon
                            fontSize="small"
                            sx={{ color: "#666" }}
                          />
                        </Grid>
                        <Grid item>
                          {candidate.latestAssessmentResult ? (
                            <Typography variant="body2">
                              Maximum travel to work:{" "}
                              <strong>
                                {
                                  candidate.latestAssessmentResult.interests
                                    .locationRadius[0]
                                }
                              </strong>{" "}
                              {config.distanceName}
                            </Typography>
                          ) : null}
                        </Grid>
                      </Grid>
                    </Grid>
                  )}
                  <Grid item>
                    <Grid container spacing={1}>
                      <Grid item>
                        <SalaryIcon
                          fontSize="small"
                          sx={{ color: "#666" }}
                        />
                      </Grid>

                      <Grid item>
                        <Typography variant="body2">
                          Salary: {salary[0]}{" "}
                        </Typography>
                      </Grid>
                    </Grid>
                  </Grid>

                  <Grid item>
                    <Grid container spacing={1}>
                      <Grid item>
                        <SchoolIcon
                          fontSize="small"
                          sx={{ color: "#666" }}
                        />
                      </Grid>

                      <Grid item>
                        <Typography variant="body2" sx={{ textTransform: "capitalize" }}>
                          Prior Attainment: {qualificationsName}
                        </Typography>
                      </Grid>
                    </Grid>
                  </Grid>

                  <Grid item>
                    <Grid container spacing={1}>
                      <Grid item>
                        <ContractIcon
                          fontSize="small"
                          sx={{ color: "#666" }}
                        />
                      </Grid>

                      <Grid item>
                        <Typography variant="body2">
                          Contract Type: {contract[0]}
                        </Typography>
                      </Grid>
                    </Grid>
                  </Grid>
                  {(showStatus && (
                    <Grid item>
                      <Grid container spacing={1}>
                        <Grid item>
                          <EmojiPeopleIcon
                            fontSize="small"
                            sx={{ color: "#666" }}
                          />
                        </Grid>

                        <Grid item>
                          <Typography variant="body2">
                            Status: {(allow_reverse_mine ? "Looking for work" : "Not looking for work") + " (" +candidateStatus +")"}
                          </Typography>
                        </Grid>
                      </Grid>
                    </Grid>
                  ))}

                  {(isInternalMobility && (
                    <>
                      <Grid item>
                        <Grid container spacing={1}>
                          <Grid item>
                            <WorkIcon
                              fontSize="small"
                            sx={{ color: "#666" }}
                            />
                          </Grid>
                          <Grid item>
                            <Typography variant="body2">
                              {"Department: " + (imDepartments[internalMobilityDepartment] ? imDepartments[internalMobilityDepartment].departmentName : "")}
                            </Typography>
                          </Grid>
                        </Grid>
                      </Grid>
                      <Grid item>
                        <Grid container spacing={1}>
                          <Grid item>
                            <GroupIcon
                              fontSize="small"
                            sx={{ color: "#666" }}
                            />
                          </Grid>
                          <Grid item>
                            <Typography variant="body2">
                              {"Line Manager: " + (imLineManagers[internalMobilityLineManager] ? (imLineManagers[internalMobilityLineManager].name + " (" + imLineManagers[internalMobilityLineManager].email + ")"): "")}
                            </Typography>
                          </Grid>
                        </Grid>
                      </Grid>
                    </>
                  ))}
                  <Grid item>
                    <Typography variant="caption" sx={{ color: "#666" }}>
                      {lastAuthenticatedAt ? (
                        <>
                          Last login: {moment(lastAuthenticatedAt).fromNow()}
                        </>
                      ) : (
                        <span>Candidate has not logged in yet.</span>
                      )}
                    </Typography>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Grid>

          <Grid item size={6}>
            <Grid
              container
              direction="column"
              justify="flex-start"
              alignItems="stretch"
            >
              {latestAssessmentCreatedAt ? (
                <Grid
                  container
                  direction="row"
                  sx={{ minHeight: 22, mb: 1 }}
                  justify="center"
                  alignItems="center"
                >
                  <Grid item size={{xs:5}}>
                    <Typography variant="button" sx={{ fontSize: 12 }}>
                      Assessment:
                    </Typography>
                  </Grid>
                  <Grid item size>
                    <Typography variant="body2">
                      <b>{assessmentVersion}</b> assessment completed{" "}
                      {moment(candidate.latestAssessmentCreatedAt).fromNow()}
                    </Typography>
                  </Grid>
                  {/* {window.location.pathname !== "/print" ? (
                    <Grid item xs sx={{ textAlign: "right" }}>
                      <OptionsMenu
                        candidate={candidate}
                        portaldetails={portaldetails}
                        auth={auth}
                      />
                    </Grid>
                  ) : null} */}
                </Grid>
              ) : (
                ""
              )}

              {desiredOccupations ? (
                <Grid container direction="row" sx={{ minHeight: 22, mb: 1 }}>
                  <Grid item size={{xs:5}}>
                    <Typography variant="button" sx={{ fontSize: 12 }}>
                      {isInternalMobility ? "Current Occupation:" : "Preferred Occupations:"}
                    </Typography>
                  </Grid>
                  <Grid item size>
                    <Typography variant="subtitle2">
                      {desiredOccupationList()}
                    </Typography>
                  </Grid>
                </Grid>
              ) : (
                ""
              )}

              {occupations ? (
                <Grid container direction="row" sx={{ minHeight: 22, mb: 1 }}>
                  <Grid item size={{xs:5}}>
                    <Typography variant="button" sx={{ fontSize: 12 }}>
                      Past Occupations:
                    </Typography>
                  </Grid>
                  <Grid item size>
                    <Typography variant="body2">
                      {occupationList()}
                    </Typography>
                  </Grid>
                </Grid>
              ) : (
                ""
              )}

              <BackpackMatches onMatchClick={onMatchClick} onJobClick={onJobClick} />
              {candidate.noJobsNearMe &&
              <Typography sx={{ mt: 1.875 }}>
                Please note: The candidate has no available jobs available based on his current criteria and preferences
              </Typography>
              }
            </Grid>
          </Grid>
        </Grid>
      </Paper>
    );
};

const CandidateSimpleDetails = ({ selectedUserData, isInternalMobility }) => {
  const [isOnPrintMode, setIsOnPrintMode] = useState(false);
  const [activeTab, setActiveTab] = useState(null);
  const [jobMatchType, setJobMatchType] = useState(null);
  const componentRef = React.useRef();

  const dispatch = useDispatch();
  const {
    selectedCandidateData
  } = useSelector((state) => state.candidates);
  const { missions } = useSelector((state) => state.portaldetails);
  const auth = useSelector((state) => state.auth);
  const portaldetails = useSelector((state) => state.portaldetails);
  const rewards = useSelector((state) => state.rewards);

  const sortedmissions = React.useMemo(() => {
    if (selectedCandidateData?.latestAssessmentResult?.results && missions) {
      // The logic for sortedmissions was commented out, so returning an empty array.
      // If it needs to be implemented, it would go here.
      return _.sortBy([], ["score"]);
    }
    return null;
  }, [selectedCandidateData, missions]);

  if (!selectedCandidateData) {
    return (
      <Grid>
        <Grid container item xs justifyContent="center">
          <CircularProgress size={25} thickness={4} />
        </Grid>
      </Grid>
    );
  }

    return (
      <Box sx={{ flexGrow: 1 }} ref={componentRef}>
        <CandidateHeader
          isInternalMobility={isInternalMobility}
          auth={auth}
          portaldetails={portaldetails}
          isOnPrintMode={isOnPrintMode}
          candidate={selectedCandidateData}
          user={selectedUserData}
          onMatchClick={() => setActiveTab(isInternalMobility ? "Redeployment" : "Jobs & Occupations")}
          onJobClick={(v) => setJobMatchType(v)}
        />
        <TabControl
          defaultTab={activeTab}
          onTabChange={() => setActiveTab(null)}
          panels={[
            {
              label: "Profile & Progress",
              render: () => (
                <CandidateSummaryView
                  getSkillsInfo={() => dispatch(getSkillsInfo())}
                  isOnPrintMode={isOnPrintMode}
                  candidate={selectedCandidateData}
                  user={selectedUserData}
                  rewards={rewards}
                  addNewSkill={(newSkills) => dispatch(addNewSkill(newSkills))}
                  editSkillLevel={(skill, level) => dispatch(editSkillLevel(skill, level))}
                  saveSkills={(skills) => dispatch(saveSkills(skills))}
                  createValidationRequest={(skill) => dispatch(createValidationRequest(skill))}
                />
              ),
            },
            {
              label: "Analytics",
              render: () => (
                <CandidateEngagement
                  getCandidateEngagements={() => dispatch(getCandidateEngagements())}
                  missions={sortedmissions}
                  portaldetails={portaldetails}
                  candidate={selectedCandidateData}
                />
              ),
            },
            {
              label: isInternalMobility ? "Redeployment" : "Jobs & Occupations",
              render: () => (
                <JobResults candidate={selectedUserData.userID} job_match_type={jobMatchType} set_job_match_type={(v) => setJobMatchType(v)
                } />
              ),
            },
            {
              label: "Other Assessments",
              disabled: isInternalMobility ? true : false,
              render: () => <OtherAssessments />,
            },
            {
              label: "Utilisation",
              disabled: isInternalMobility ? false : true,
              render: () => <Utilisation />,
            }
          ]}
        />
      </Box>
    );
};

export default CandidateSimpleDetails;
